import { FC } from 'react';

import { useFormik } from 'formik';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import { PayOutDiamondsForm } from '../../../../form';

import { userService } from 'v2/api/userService';
import { UserModel } from 'v2/types/UserModel';
import { handleHttpError } from 'v2/utils';

interface PayOutDialogProps {
  user: UserModel;
  isOpen: boolean;
  onClose: VoidFunction;
  onRevalidate: VoidFunction;
}

export const PayOutDialog: FC<PayOutDialogProps> = ({ user, isOpen, onClose, onRevalidate }) => {
  const { trigger, isMutating } = useSWRMutation(['updateUser', user.id], userService.updateUser, {
    onSuccess: (user) => {
      onRevalidate();
      toast.success(`Diamonds are credited to ${user.userNickname}`);
      handleClose();
    },
    onError: handleHttpError,
  });

  const formik = useFormik<PayOutDiamondsForm>({
    initialValues: { amount: '' },
    onSubmit: (values) => {
      trigger({ diamonds: Number(values.amount) + user.diamonds });
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Pay Out Diamond For {user.userNickname}</DialogTitle>

      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <TextField
            name="amount"
            value={formik.values.amount}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Amount"
            type="number"
            fullWidth
            required
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="error" variant="outlined">
            Cancel
          </Button>

          <Button type="submit" variant="contained" loading={isMutating}>
            Pay Out
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
